import React from "react";
import "./CardLoader.css";

const CardLoader = () => {
  return (
    <div className="loader-card">
      <div className="loader-left">
        <div className="skeleton avatar"></div>
      </div>
      <div className="loader-middle">
        <div className="skeleton title"></div>
        <div className="skeleton meta-line"></div>
        <div className="skeleton tag"></div>
        <div className="skeleton posted-by"></div>
      </div>
      <div className="loader-right">
        <div className="skeleton image-thumb"></div>
      </div>
    </div>
  );
};

export default CardLoader;
